import { defineStore } from 'pinia';

export const useBookmarksStore = defineStore('bookmarks', {
	state: () => {
		return {
			lastUpdateInMonolith: 0 as number,
		};
	},
});
